module.exports = {
  "CS_tickets_Search_dVXa": "Поиск",
  "CS_info2_Network_Image_HvHe": "Изображение с веб-сайта",
  "CS_improvement_Driver_ZOiL": "Водитель",
  "CS_5_When_the_PbND": "Этот пользователь является клиентом. Доступны только инструменты клиента.",
  "CS_reconstruction_Determination_MvvP": "Подтвердить",
  "CS_2_Time_of_ynEo": "Время возврата средств",
  "CS_1_operator_gItF": "Исполнитель",
  "CS_info_Comments_failed_mQNX": "Не удается добавить комментарий",
  "CS_info2_Image_address_QJoY": "URL-адрес изображения",
  "CS_5_Do_not_kYRj": "Слишком много попыток",
  "CS_tickets_Type_of_DvxN": "Тип обращения",
  "CS_tickets_Half_a_SjoS": "Последние 6 месяцев",
  "CS_2_It_is_vdcu": "Сначала ответьте через сервис сообщений в приложении (также будет отправлено уведомление по электронной почте). Если вы не знаете, как это сделать, обратитесь к своему руководителю.",
  "CS_1_Template_oNtV": "Шаблон",
  "CS_tickets_User_Type_Wdya": "Тип пользователя",
  "CS_info_Into_the_OLWz": "Пользователь, выполнивший запрос (info)",
  "CS_info2_Please_fill_uLvw": "Введите...",
  "CS_page_Unable_to_sJgg": "Не удалось решить проблему из обращения",
  "CS_1_Passengers_rXbp": "Клиент",
  "CS_page_Unable_to_lQkV": "Не удалось закрыть обращение",
  "CS_info2_Cancel_link_vxaa": "Удалить ссылку",
  "CS_1_Action_pnrH": "Действия",
  "CS_pop_The_conversation_dKAF": "Время начала звонка",
  "CS_1_Operational_results_nOpZ": "Результат действия",
  "CS_1_Compensation_Deduction_eyNT": "Подробные сведения о компенсации/вычете",
  "CS_page_Unable_to_lWwm": "Не удалось временно сохранить обращение",
  "CS_Page_Passenger_ID_WiFY": "Идентификатор клиента",
  "CS_Page_Clear_Query_qLSf": "Очистить критерии поиска",
  "CS_1_Temporary_CTPp": "Сохранить временно",
  "CS_1_Solved_ooGh": "Решено",
  "CS_page_Unable_to_aXip": "Не удалось создать обращение",
  "CS_info2_View_link_fyZT": "Посмотреть ссылку",
  "CS_1_Message_Title_AJzH": "Тема электронного письма",
  "CS_2_Worksheet_ID_SxiT": "Идентификатор обращения сгенерирован во время создания обращения",
  "CS_tickets_Work_order_STXN": "История обращений",
  "CS_2_Copy_successfully_rlpe": "Скопировано",
  "CS_2_Copy_the_hSGF": "Номер телефона скопирован. Действие записано в журнал. Соблюдайте политики информационной безопасности компании.",
  "CS_Page_Driver_Details_Mnzk": "Страница «Сведения о водителе»",
  "CS_page_Successful_temporary_sFHU": "Обращение временно сохранено",
  "CS_page_Successfully_created_ffvZ": "Обращение создано",
  "CS_Page_Purpose_rNGk": "Место высадки",
  "CS_Tools_1231_Optimus_AdyenTool_Failure_TWRQ": "Не выполнено",
  "ark.global.cs.field.values.ticket_tab_im": "Онлайн-чат",
  "CS_qa_This_behavior_dZrQ": "Действия, выполненные на этой странице, занесены в журнал. Следуйте политике информационной безопасности компании.",
  "CS_1_Status_of_Dkxj": "Статус",
  "CS_reconstruction_Select_Business_DYpG": "Выберите тип сервиса",
  "CS_Page_Driver_List_Uxwj": "Список водителей",
  "CS_1_Thank_you_WUlL": "Спасибо за отзыв!",
  "CS_info_Select_Question_QkZC": "Выберите причину обращения",
  "CS_5_Your_query_uvJB": "Достигнут максимум запросов",
  "CS_Page_Rider_Details_Ovwp": "Сведения о клиенте: идентификатор клиента",
  "CS_1_Amount_mYAW": "Сумма",
  "CS_Page_Order_Details_oAUq": "Сведения о поездках: идентификатор поездки",
  "CS_Settings_Can_not_wuTx": "Поле должно быть заполнено",
  "CS_1_Action_Name_sFel": "Действие",
  "Fleet_0303_Fleet_WorkRegime_Contents_TAuX": "Содержание отсутствует",
  "CS_Tools_1209_Optimus_Coupon_Inuquiry_Scope_of_bBLW": "Идентификатор клиента",
  "CS_Page_Driver_Details_uNcn": "Сведения о водителе: идентификатор водителя",
  "CS_page_Please_fill_ikWU": "Выберите группу обращений",
  "CS_tickets_Three_days_pcmE": "Последние 3 дня",
  "CS_pop_Action_zZIq": "Действия",
  "CS_1_Enter_content_haAO": "Введите текст здесь",
  "CS_pop_Confirmation_lTpQ": "ОК",
  "CS_improvement_Phone_records_Kgdt": "История вызовов",
  "CS_info2_Association_ZCdq": "Связать",
  "CS_1_Work_orders_fADf": "Внутреннее сообщение отправлено по обращению",
  "CS_qa_Collapse_DJRI": "Свернуть",
  "CS_improvement_Voice_duration_TNdW": "Длительность вызова",
  "CS_1_Work_order_pUHt": "Электронное письмо отправлено по обращению",
  "CS_1_Mail_address_Hxvv": "Электронный адрес",
  "CS_page_Work_orders_MRDt": "Обращение закрыто",
  "CS_tickets_Compensation_deduction_GJfV": "Способ компенсации/вычета",
  "CS_info_Like_failure_mPup": "Возникла ошибка. Повторите попытку.",
  "CS_info2_Make_sure_zyfT": "Прежде чем выбрать этот вариант, проверьте, что для этого обращения недоступна информация о городе",
  "verify---id_no_co": "Подтвердить",
  "CS_Page_Driver_ID_HNzY": "Идентификатор водителя",
  "CS_info_Select_a_CKYG": "Выберите город. Если город недоступен, можно выбрать пункт «Н/Д».",
  "CS_4_Topographic_tools_KqUl": "Карта",
  "CS_Page_Driver_Type_UnIR": "Тип водителя",
  "Magellan_improvement_When_you_WyDX": "При закрытии заказы отменяются. Будьте внимательны при выборе действия.",
  "CS_tickets_Compensation_ID_PjEu": "Идентификатор компенсации",
  "CS_5_When_the_WPIZ": "Этот пользователь является водителем. Доступны только инструменты водителя.",
  "CS_information_Order_Basis_WKGU": "Основная информация о поездке",
  "CS_1_Send_email_oriC": "Отправить электронное письмо",
  "CS_tickets_One_week_YsBK": "Последняя неделя",
  "CS_page_Whether_the_pGhP": "Проблема из обращения решена? После подтверждения статус обращения изменится на «[Идет обработка]».",
  "CS_2_For_security_YqmP": "Электронный адрес получателя скрыт из соображений безопасности. Это не повлияет на возможность коммуникации.",
  "CS_info_Please_fill_yjjm": "Введите номер телефона",
  "CS_info2_Business_Type_KDsP": "Тип сервиса",
  "CS_1_Send_internal_kufI": "Отправить сообщение",
  "CS_1_Save_dSGz": "Сохранить",
  "CS_page_Priority_processor_Gwtc": "Предпочтительное назначенное лицо",
  "CS_1_The_author_xIBI": "От",
  "Magellan_improvement_The_company_CoIp": "Такая информация, как мгновенные сообщения и история вызовов, является конфиденциальной и принадлежит компании. Используйте ее надлежащим образом согласно правилам информационной безопасности. Каждый запрос будет регистрироваться системой. Строго запрещается делать фотографии, содержащие такую информацию, а также скачивать или раскрывать ее любым третьим лицам за пределами компании.",
  "CS_Page_Passenger_Details_vgGv": "Страница «Сведения о клиенте»",
  "CS_page_If_you_RZwt": "Временно сохранить это обращение? Статус обращения изменится на «[Временно сохранено]».",
  "CS_page_Work_order_vikw": "Проблема из обращения решена",
  "CS_pop_No_xtIB": "Нет",
  "CS_pop_Cancel_byla": "Отмена",
  "CS_1_Type_kuvZ": "Тип",
  "Magellan_improvement_IM_Information_weuP": "Информация о мгновенных сообщениях",
  "CS_1_Role_QhMU": "Роль",
  "CS_info2_Reset_Fiiu": "Сбросить",
  "CS_1_E_mail_rKAg": "Электронное письмо",
  "CS_tickets_Administrator_BcHW": "Менеджер",
  "Magellan_improvement_Question_description_GyVD": "Описание проблемы",
  "CS_2_Refund_history_NZXS": "История возвратов средств",
  "CS_page_Do_you_UfOG": "Передать обращение в группу «{{ticketgroup}}»?",
  "CS_info2_Related_Worksheets_TnzD": "Связать обращение (необязательно)",
  "CS_page_Transportation_orders_UWhR": "Передать обращение",
  "CS_tickets_One_month_IrdR": "Последний месяц",
  "CS_Page_City_XSgD": "Город",
  "CS_qa_Customer_Service_CeXF": "Специалист службы поддержки",
  "CS_Page_Passenger_List_ajVZ": "Список клиентов",
  "CS_5_Unchecked_user_vuUZ": "Сведения о регистрации пользователя не найдены",
  "CS_1_Latest_before_UTUl": "Отсортировать по самым новым",
  "CS_Settings_Countless_lEdc": "Нет данных",
  "CS_page_Transferring_the_ZnkX": "Обращение передано",
  "CS_5_Copy_successfully_CcCu": "Скопировано",
  "CS_1_During_Operation_xWpb": "Время действия",
  "Magellan_improvement_Call_completed_hbKz": "Вызов завершен",
  "CS_improvement_Passenger_JnXD": "Клиент",
  "CS_Page_Driver_Basic_SItd": "Общие сведения о водителе",
  "CS_qa_More_Paqa": "Еще",
  "CS_info_Select_Channel_HWlg": "Выберите канал",
  "CS_info2_Rider_Issuing_TDAx": "Время заказа поездки клиентом",
  "CS_4_Contact_Records_NcjV": "История контактов",
  "CS_4_Tools_can_ZQSK": "Все инструменты могут быть использованы только на странице обработки обращений системы CS.",
  "ark.global.cs.TOOL_ACTION_associated_ticket": "Связал(-а) обращение",
  "Magellan_improvement_Information_Secure_LRtP": "Напоминание о конфиденциальности информации",
  "CS_Page_Model_List_WVIO": "Список классов автомобилей",
  "CS_Page_Enter_driver_CirL": "Укажите идентификатор водителя",
  "CS_Page_Common_tools_FTJG": "Стандартные инструменты",
  "CS_Page_Select_driver_rrhQ": "Выберите тип водителя",
  "CS_qa_There_is_vPke": "{{inputbox}} содержит неотправленное содержимое. Если вы покинете эту страницу, содержимое будет удалено. Покинуть страницу?",
  "CS_info_Click_here_MKRf": "Нажмите здесь, чтобы связать 1 заказ",
  "CS_info_Mobile_phone_SGyc": "Не удается найти информацию о пользователе, поскольку номер телефона недействителен либо пользователь не зарегистрирован.",
  "CS_3_Optional_kdMP": "необязательно",
  "CS_pop_User_Phone_hTGd": "Номер телефона пользователя",
  "CS_Page_City_name_atjF": "Название города",
  "CS_information_Departure_zaxW": "Место отправления",
  "CS_TicketHandlingPage_This_CR_VWpW": "Ручная обработка SOP уже поддерживается для этой причины обращения. Обработайте обращение в соответствии с SOP.",
  "CS_improvement_Call_SmCo": "Время вызова",
  "CS_2_Work_Order_anVq": "Группа обращений",
  "CS_info_Select_Business_bhhu": "Выберите тип сервиса",
  "CS_1_Comments_RcMN": "Отправить",
  "CS_info_This_page_Cpww": "Для обеспечения корректной работы на этой странице можно открывать не более 10 вкладок с обращениями. Закройте ненужные вкладки. Спасибо!",
  "CS_information_Order_ID_vVme": "Идентификатор поездки",
  "CS_4_Order_details_ulUl": "Сведения о поездке",
  "CS_tickets_Work_order_NQJE": "Статус обращения",
  "CS_info2_If_there_BivS": "Выберите связанное обращение (при наличии)",
  "CS_Page_Billing_models_otMq": "Тип автомобиля",
  "CS_Page_Enter_your_kKAs": "Укажите номер телефона",
  "CS_page_No_email_Uhdl": "У вас нет прав на отправку ответного электронного письма",
  "CS_tickets_Three_months_Jdzc": "Последние 3 месяца",
  "CS_1_Order_ID_bsCY": "Идентификатор заказа",
  "CS_tool_Work_order_LjeC": "Статус обращения",
  "CS_Page_Trip_Compl_Vcnk": "Время окончания поездки",
  "CS_1_Compensation_deduction_pTJS": "Канал компенсации/вычета",
  "CS_page_No_permissions_mYZG": "У вас нет прав на передачу этого обращения",
  "CS_1_Send_email_DDPi": "Подтвердите отправку электронного письма",
  "CS_info2_More_akQx": "Показать больше",
  "CS_1_Work_orders_cLNO": "Сообщение в приложении отправлено по обращению",
  "CS_1_Roaming_wzIe": "Роуминг",
  "CS_Page_Select_the_kqHS": "Выберите условия фильтрации",
  "CS_5_Copy_qVgF": "Копировать",
  "CS_Page_Star_Standard_ICmt": "Рейтинг",
  "CS_translation_Selection_of_yatg": "Выбрать причину обращения",
  "CS_2_Please_select_Zapc": "Выберите",
  "CS_2_Refund_amount_ikWV": "Сумма возврата",
  "CS_initialization_Select_Order_dqhz": "Выберите поездку",
  "CS_TicketHandlingPage_Artificial_SOP_vwXh": "Ручная обработка SOP",
  "CS_Page_Enter_Order_TeQM": "Введите идентификатор поездки",
  "CS_Page_Passenger_Email_qveC": "Электронный адрес клиента",
  "CS_Page_Between_the_eqMJ": "Время создания",
  "CS_Page_Business_Type_nsHy": "Тип сервиса",
  "CS_page_Do_you_tMFN": "Закрыть это обращение?",
  "CS_Page_Type_SnKr": "Модель",
  "CS_2_Work_Order_fABY": "Идентификатор обращения скопирован",
  "CS_QA1_More_than_uScx": "Если элементов больше {{amount}}, будут показаны только {{amount}}.",
  "CS_Page_Pick_up_CNzD": "Место подачи",
  "More": "Еще",
  "CS_1_ID_VNVI": "Идентификатор обращения",
  "CS_pop_Bind_session_qEwk": "Добавить звонок",
  "CS_improvement_Unanswered_qcLt": "Без ответа",
  "CS_info2_Jump_link_pUcH": "Перенаправить по ссылке",
  "CS_tickets_The_user_iVJx": "Этот пользователь является менеджером таксопарка (нажмите, чтобы посмотреть подробности)",
  "CS_1_Related_Orders_hkRo": "Связать заказ",
  "ark.global.cs.field.values.ticket_tab_compensation": "Обработка записи",
  "CS_info2_Depositary_UmEY": "Назначенное лицо",
  "CS_initialization_Create_a_xRhB": "Сначала создайте обращение",
  "CS_pop_Bind_lDQM": "Добавить",
  "CS_info_Comments_successfully_YcZj": "Комментарий добавлен",
  "CS_Page_Order_List_IiWy": "Список заказов",
  "CS_tickets_Enter_the_FCWt": "Обращение, связанное с пользователем",
  "CS_information_Booking_session_CBQY": "Запланированное время",
  "ark.global.cs.field.values.ticket_tab_inner_reply": "Внутреннее сообщение",
  "CS_Page_Driver_ID_TPqW": "Серия и номер паспорта водителя",
  "CS_info_Select_Work_KXNc": "Выберите группу обращений",
  "CS_information_Single_phone_vKdi": "Номер телефона заказчика",
  "Help_conversations_Robot_chat_QzDc": "История переписки с чат-ботом",
  "CS_2_Driver_balance_otCh": "Списание с баланса водителя",
  "CS_Notice_Please_submit_iVZB": "Перед отправкой оставьте отзыв к этой карте процесса.",
  "CS_tickets_Between_the_mEqx": "Время создания",
  "CS_2_Passenger_Basic_FFNN": "Основная информация о клиенте",
  "CS_page_Do_you_GgIB": "Передать обращение {{handler}} в группу «{{ticketgroup}}»?",
  "CS_info2_Link_kBeS": "Связка",
  "CS_1_You_do_Czvx": "У вас нет прав на просмотр личных данных клиентов. Выполните автоматическую верификацию или обратитесь к администратору.",
  "CS_info_Process_cards_ccmd": "Карта процесса",
  "CS_1_Enter_text_NYGo": "Введите текст...",
  "CS_improvement_The_main_DIgv": "Абонент положил трубку",
  "CS_1_Compensation_ID_BGFF": "Идентификатор компенсации",
  "Help_2_More_OZUg": "Еще",
  "CS_1_Recipients_jNBa": "Кому",
  "CS_1_Work_order_wyuA": "Информация по обращению",
  "CS_info_Select_User_rSZo": "Выберите тип пользователя",
  "CS_Page_Enter_email_VDKC": "Укажите электронный адрес",
  "CS_tickets_Complaint_Manner_UWAQ": "Обращение, связанное с каунтерпартнером",
  "ark.global.cs.field.values.ticket_tab_asyc_msg": "Сообщение в приложении",
  "CS_2_Refundable_mKnQ": "Доступен ли возврат средств?",
  "CS_pop_Whether_to_tvgd": "Создать обращение без связанного звонка?",
  "CS_1_Send_an_oyHo": "Действительно отправить электронное письмо этому пользователю?",
  "CS_pop_Can_t_QjXi": "Связанный звонок не найден?",
  "CS_tickets_Order_Work_UDue": "Обращение, связанное с заказом",
  "Magellan_improvement_ID_HTMT": "Идентификатор обращения",
  "ark.global.cs.field.values.ticket_tab_outer_reply": "Внешний ответ",
  "CS_Page_Type_of_Chyl": "Тип запроса",
  "CS_initialization_Select_user_QGGG": "Выберите тип пользователя",
  "CS_5_Comply_with_YDuq": "Следуйте политике информационной безопасности компании.",
  "CS_prompt_Driver_registration_mBqS": "Задание по проверке регистрации водителя не найдено",
  "CS_improvement_Dial_man_vuMm": "Абонент",
  "CS_info2_Data_Not_mVCx": "Доступных данных нет",
  "CS_information_Purpose_tIXL": "Место назначения",
  "CS_Page_Response_mode_tfSQ": "Режим ответов",
  "CS_Page_Order_ID_tWzK": "Идентификатор заказа",
  "CS_Page_Order_Status_ZJEQ": "Статус заказа",
  "CS_1_Internal_message_Dmzz": "Внутреннее сообщение",
  "CS_1_More_online_ugOQ": "Показать больше записей журнала чата",
  "CS_Page_Status_of_SBuB": "Статус платежа",
  "CS_Page_Enter_ID_IgwX": "Укажите серию и номер паспорта",
  "TEXT_ERRMSG_OK": "Успешно",
  "CS_translation_Submission_akuK": "Отправить",
  "CS_Page_Driver_Mobile_mQCL": "Номер телефона водителя",
  "CS_Page_Passenger_Mobile_ckjq": "Номер телефона клиента",
  "CS_qa_User_Tjti": "Пользователь",
  "CS_1_Help_us_ilXL": "Помогите нам стать лучше",
  "CS_info_Select_user_WEYA": "Выберите тип пользователя и тип сервиса, чтобы отобразить доступные причины обращения",
  "CS_information_Order_Status_ZZvi": "Статус поездки",
  "CS_Page_Please_choose_SkUr": "Выберите…",
  "CS_initialization_Select_City_uKvx": "Выберите город",
  "CS_pop_Bind_fsRd": "Добавлено",
  "CS_2_Classification_of_QmXS": "Причина обращения",
  "CS_1_Off_aqDQ": "Закрыть",
  "CS_info2__unk_MkzP": "Загрузить изображение",
  "kfcommon-fe-i18n-knowledge---knowledgeConfig.robot": "Роботы",
  "ark.global.cs.field.title.ticket_tab_log": "Журнал обращений",
  "CS_qa_Successfully_saved_GaYt": "Обращение сохранено",
  "CS_info2_User_Type_ylaU": "Тип пользователя",
  "CS_pop_Yes_yDMc": "Да",
  "CS_1_Send_asynchronous_rowd": "Отправить сообщение в приложении и электронное письмо",
  "CS_1_Cancel_UVIs": "Отмена",
  "CS_info2_link_Text_Gvnh": "Связанная информация",
  "CS_tickets_One_year_gmPi": "Последний год",
  "CS_page_Internal_reply_pruf": "Поле внутреннего ответа должно быть заполнено",
  "CS_Page_Enter_Passenger_vcdv": "Укажите идентификатор клиента",
  "ark.global.cs.field.title.ticket_tab_info": "Информационная запись",
  "CS_Page_Front_ID_apqL": "Сведения о таксопарке: идентификатор таксопарка",
  "CS_1_User_Name_dhWx": "Имя пользователя",
  "CS_info2__unk_RIxc": "Вставить",
  "CS_tickets_Compensation_Deducperiod_HFiB": "Время выполнения компенсации/вычета",
  "CS_info2_Picture_text_mnMQ": "Описание изображения",
  "CS_1_User_Mobile_aNYY": "Номер телефона пользователя",
  "CS_info2_All_orders_yVmI": "Отображаются заказы для этого пользователя за последние 180 дней",
  "CS_Page_Product_line_gPCE": "Линия продуктов",
  "CS_info_There_is_vxeJ": "Содержимое недоступно для этой причины обращения. Дополнительную информацию см. в (базе знаний).",
  "CS_1_The_oldest_vXHS": "Отсортировать по самым старым",
  "CS_tickets_Today_klqB": "Сегодня",
  "CS_monitor_Each_compensation_BfxO": "Все запросы на компенсацию вносятся в журнал. Убедитесь в том, что запросы соответствуют политике компенсации через службу поддержки. Запросы, которые не соответствуют правилам политики, будут обработаны вручную.",
  "comTool.channelRefundERR": "Счет для этого заказа не указан, поэтому возврат средств по первоначальному каналу невозможен.",
  "review.auditInfo": "Подробные сведения",
  "chat.onlineResponse": "Сообщение в приложении",
  "list.orderId": "ID Заказа",
  "comTool.refundStatus": "статус возврата",
  "common.pleaseSelect": "выбрать",
  "new.tags": "теги",
  "comfort.vehicleModel": "Модель транспортного средства",
  "review.auditTime": "Время проверки",
  "comfort.requiredYear": "Год >",
  "staticConfig.no": "нет",
  "chat.save": "Сохранить",
  "review.submitReview": "Отправить на проверку",
  "staticConfig.businessTypeName": "Название типа предприятия",
  "new.NullEmergencyContact": "Пользователь не указал контактное лицо при ЧС",
  "new.emergencyContact": "контактное лицо при ЧС",
  "common.confirm": "Подтвердить",
  "new.continueHandle": "продолжить работу с",
  "comTool.driverV": "Невозможно выплатить компенсацию, поскольку тип пользователя — «ПАССАЖИР»",
  "comfort.model": "Модель транспортного средства",
  "comTool.balance": "баланс",
  "automation.action": "действие",
  "clipper.T3first": "Время получения обращения T3",
  "common.abnormalReminder": "Уведомление о риске",
  "new.editTime": "время изменения",
  "list.compensatePhone": "Телефон пользователя",
  "work.businessTypeName": "Тип Сервиса",
  "comTool.pay": "Пассажиры",
  "review.undoChanges": "Отменить изменения",
  "new.orderInfo": "Информация о заказе",
  "review.viewFlowchart": "Посмотреть схему процесса",
  "comTool.channelName": "название канала",
  "comTool.riderCompensation": "Компенсация клиенту",
  "comTool.driverActualRevenue": "Фактический доход водителя",
  "callInfo.operation": "Операция",
  "clipper.creationDate": "Время создания обращения Clipper",
  "comTool.driverId": "Идентификатор водителя",
  "new.knowdgeBase": "База знаний",
  "common.continueTocompensate": "Все равно компенсировать",
  "comTool.passenger": "Пассажир",
  "comTool.coupon": "Купон",
  "list.channel": "канал",
  "clipper.clipperTitle": "Информация о связанном обращении по безопасности Clipper",
  "list.amountRange": "Диапазон суммы  ",
  "comTool.reasonForCompensation": "Причина компенсации",
  "comTool.channelRefund": "возврат средств по первоначальному каналу",
  "clipper.ticketID": "Идентификатор обращения Clipper",
  "comTool.driverPhone": "Номер телефона водителя",
  "review.commitTime": "Время отправки",
  "common.system": "система",
  "common.more": "дополнительно",
  "comfort.search": "Поиск",
  "comTool.amountERR": "Ошибка при вводе суммы",
  "clipper.T2first": "Время получения обращения T2",
  "staticConfig.yes": "да",
  "staticConfig.operationSuccessfully": "Операция выполнена",
  "new.PleaseCreateTicket": "Сначала создайте обращение",
  "list.worksheetId": "Идентификатор обращения",
  "comTool.status": "статус платежа",
  "comTool.refund": "возврат средств",
  "comTool.driverDeduction": "Списание с водителя",
  "new.ticketRefreshV": "Обращение изменено. Продолжить?",
  "common.jingmoThreeMonths": "Показать только журнал режима «Без приема» за последние три месяца",
  "comTool.refundCost": "сумма возврата",
  "detail.handle": "работать с",
  "new.fileBig": "слишком большой файл. Выберите файл размером не более 5 МБ",
  "list.amount": "Сумма",
  "create.NewTicket": "Новое обращение",
  "review.auditResult": "Результат",
  "new.editUser": "кем изменено",
  "review.auditor": "Кем проверено",
  "common.Toolbox": "Панель элементов",
  "common.ticketList": "Список обращений",
  "comfort.city": "Город",
  "review.taskName": "Тип задания",
  "staticConfig.channelSetting": "настройки канала",
  "comTool.detailsOfCompensation": "Подробные сведения о компенсации",
  "review.modify": "Изменить",
  "clipper.clipperDetail": "С этим обращением связано обращение по безопасности Clipper",
  "detail.handleV": "Обращение находится в обработке. Действительно получить его?",
  "comTool.driverCompensation": "Компенсация водителю",
  "review.submitReviewConfirm": "Действительно отправить эту информацию на проверку?",
  "new.uploadFailed": "не удалось загрузить. Повторите попытку",
  "comTool.operationStatus": "результат",
  "new.refreshTicket": "обновить эту страницу",
  "clipper.status": "Статус обращения Clipper",
  "comTool.routeOfCompensation": "Способ компенсации",
  "review.actions": "Действия",
  "common.recommendationNotcompensate": "Рекомендация: не выплачивать компенсацию.",
  "comTool.passengerCouponV": "Невозможно запросить купон, поскольку тип пользователя — «ВОДИТЕЛЬ»",
  "common.to": "изменить на",
  "work.Workbench": "Мое рабочее место",
  "comTool.noOrderAll": "Заказ для этого обращения не указан, поэтому компенсация невозможна.",
  "comTool.cost": "сумма платежа",
  "clipper.clickToView": "Нажмите, чтобы посмотреть",
  "common.up": "Свернуть",
  "chat.transfer": "Перевод",
  "CS_one_Batch_configuration_Ffmp": "Batch Configuration",
  "CS_one_Scenario_ENG_mFbn": "Scenario (en-US)",
  "CS_one_Operation_Log_hsdo": "Action Log",
  "CS_one_Tips_vbZx": "Attention",
  "CS_one_Upload_successfully_DliZ": "File uploaded successfully. It will take effect in the applicable country after being created. Please inform the relevant colleagues in the corresponding country.",
  "CS_one_Upload_files_TzsC": "Upload File",
  "CS_one_Please_check_SuZo": "2. Upload the completed template (make sure everything is entered correctly before uploading).",
  "CS_one_Enter_rfGy": "Please enter",
  "CS_one_Classification_of_qEgR": "Contact Reason Management",
  "CS_one_Determination_GUbi": "Confirm",
  "CS_buchong_eFit_JNbR": "Unable to find order info because mobile number is invalid, or user is not registered.",
  "CS_Adjustment_YdjN_bXSL": "Reason for skipping SOP is inadequate. Please try a different one.",
  "CS_Adjustment_gjOY_YpxQ": "SOP information is inconsistent with PC information",
  "CS_buchong__yLly": "Unable to use tools because the mobile number is invalid, or the user is not registered",
  "CS_one_Batch_effective_prPl": "Batch Validate",
  "CS_one_Country_and_Qyqv": "Country and Business Line Configuration",
  "CS_one_New_Batch_wEKW": "Batch Create",
  "CS_one_Abandoned_ROgG": "Discarded",
  "CS_one_Description_ENG_vIZz": "Description (en-US)",
  "CS_one_Translation_configuration_lnQZ": "Translation Configuration",
  "Help_version_Business_lines_VOJX": "Category",
  "CS_Service_The_driver's_JbyZ": "Driver’s level was {{driver_level}} when this ticket was created",
  "CS_one_Action_Type_uHTo": "Action Type",
  "CS_one_Description_NrBC": "Description",
  "CS_Adjustment_abEf_PYol": "SOP contains a bug",
  "CS_one_Owner_EwUa": "Owner",
  "CS_thpoptimization__sSiH": "Fleet",
  "CS_Service_Driver_Level_qpqY": "Driver Level",
  "Help_version_Enter_number_MyWJ": "Incoming Phone No.",
  "CS_one_Entered_into_mEwl": "In Effect",
  "CS_Adjustment_txhj_lfbO": "Please complete SOP before proceeding",
  "CS_buchong__BYdr": "Unable to locate user info or use the dynamic permissions verification feature because the mobile number is invalid, or the user is not registered.",
  "CS_one_New_Problem_ORNp": "Create New Contact Reason",
  "Help_version_Country_XKEj": "Country",
  "CS_one_Operation_Records_bTgJ": "Action Log",
  "CS_one_Status_QWZW": "Status",
  "CS_page_Site_Name_dYcm": "Stop Name",
  "CS_page__unk_uZmz": "Minibus Info",
  "CS_buchong1__XPiG": "Unable to perform this action because dynamic authentication failed. Please complete dynamic authentication, or contact the administrator.",
  "CS_one_Return_axWQ": "Back",
  "CS_one_Upload_failed_tubs": "Unable to upload. Please try again.",
  "Help_version_Answer_DVQw": "Answer",
  "CS_one_Are_you_QXby": "Are you sure you want to modify this contact reason? Once modified, the CR will take effect in the applicable country. Please inform the relevant colleagues in the corresponding country.",
  "CS_page_Cancelled_xyYr": "Cancelled",
  "CS_one_1_Please_EOBr": "1. Download and fill out the following template.",
  "CS_one_Applicable_States_HNdh": "Applicable Country",
  "CS_one_Basic_information_akKk": "Basic Information",
  "CS_one_Father_classification_ZASx": "Parent Category Level 1 (en_US)",
  "CS_one_Import_data_zhsI": "Import Data",
  "CS_one_Applicable_Business_ERQA": "Applicable Business Type",
  "CS_one_Cancel_sSYi": "Cancel",
  "CS_one_Add_VToU": "Add",
  "CS_one_Download_Template_XYvP": "Download Template",
  "CS_notification_dwyv_UnUJ": "This inbound user is a fleet partner. Only Fleet tools are applicable.",
  "CS_one_Scenarios_qeVe": "Scenario",
  "CS_one_Grade_classification_sVNq": "Parent Category",
  "CS_thpoptimization_Copy_the_CPlW": "Email address copied. This action has been logged. Please remember to follow the company’s information security policies.",
  "CS_Adjustment_VsHy_RwJo": "Please enter a reason for skipping",
  "Help_buchong_Reply_RcHf": "Reply",
  "CS_one_Classification_of_YYEd": "Is this a security-related contact reason (CR)?",
  "CS_page_Actual_arrival_YPiM": "Actual Arrival Time",
  "CS_one_Please_confirm_BmHM": "Please confirm the selected contact reasons and click \"Confirm\" to validate them.",
  "CS_one_Off_Zqiv": "Close",
  "CS_one_Details_Page_mdDC": "Contact Reason Details Page",
  "CS_one_Please_confirm_ViBj": "Please confirm the selected contact reasons and click \"Confirm\" to discard them.",
  "CS_page_This_order_jAmf": "Trip Stops",
  "CS_one_Please_select_IHKO": "Please select a country and a business line",
  "CS_one_During_Operation_JDju": "Action Time",
  "CS_one_Father_classification_lZII": "Parent Category Level 2 (en_US)",
  "CS_one_Export_data_YQDj": "Export Data",
  "CS_Adjustment_ZMnG_gsAL": "Other",
  "CS_one_User_Type_iRnJ": "User Type",
  "CS_one_Edit_LtHm": "Edit",
  "CS_Adjustment_VZmt_VnjZ": "Please select a reason for skipping",
  "CS_Adjustment_oVPm_qPQP": "User is offline or has exited chat",
  "CS_one_View_miAp": "View",
  "CS_fits_OUZR_woGE": "Order Product Line",
  "CS_page_Estimated_arrival_QwhV": "Estimated Arrival Time",
  "CS_compensation_Refusal_of_hveW": "Compensation Rejected",
  "CS_one_Classification_of_QAlG": "Contact Reason",
  "Help_version_Telephone_entry_PGun": "Phone Bar",
  "CS_one_You_can_MflO": "Special characters are not allowed, except for “()”, “?”, and spaces",
  "CS_one_operator_Itcg": "Operator",
  "CS_one_Organization_eUqC": "Organization",
  "CS_one_Classification_of_jyqM": "Contact Reason (en_US)",
  "Help_want__Change_pUeS": "More suggestions",
  "Help_version_Thread_tmgY": "Contact Reason",
  "CS_one_Classification_of_AlnN": "Contact Reason (en_US)",
  "CS_one_Are_you_eqhN": "Are you sure you want to create a new contact reason? Once created, the new CR will take effect in the applicable country. Please inform the relevant colleagues in the corresponding country.",
  "CS_one_Batch_scrap_qzlO": "Batch Discard",
  "CS_Tools_colombo_tool_platform_Cancel_gNzm": "Cancel",
  "CS_one_Parental_classification_zEhp": "Parent Category (en_US)",
  "Help_buchong_Reply_Record_dsUU": "Reply History",
  "staticConfig.false": "no",
  "staticConfig.true": "yes"
}